import InputFormField from "components/form/input";
import Button from "components/ui/button";
import Popper from "components/ui/popper";
import CleanButton from "components/utils/CleanButton";
import bdaylytics from "components/utils/analytics/bdaylytics";
import copy from "copy-to-clipboard";
import { useApp, useQueryDict } from "hooks/app";
import PropTypes from "prop-types";
import React from "react";
import { FaCheck } from "react-icons/fa";

const MagicLink = ({ marketingId, withPopper, link, className, buttonTitle, buttonProps, inputProps, type, children, onSuccess }) => {
  const { showAlert } = useApp();
  const { search } = useQueryDict();

  const onFocus = (e) => {
    e.target.select();
  };

  const onCopy = () => {
    copy(link);
    bdaylytics.track("Magic Link", { search, marketingId }, "Magic Link", "Click");
    if (!withPopper) {
      showAlert({ message: "Link copied! To use it, open your email or message app and use the 'Paste' option." });
    }
    onSuccess && onSuccess();
  };

  const popperContent = (
    <span className="clipboard-info">
      <span className="info-title">
        <FaCheck style={{ marginRight: 5, color: "#17a17e" }} />
        Link Copied
      </span>
    </span>
  );

  if (!link) {
    return null;
  }

  return (
    <div className={className}>
      {type === "form" && (
        <div className="clipboard-wrapper">
          <InputFormField value={link} name="magicLink" onFocus={onFocus} onClick={onCopy} readOnly {...inputProps} />
        </div>
      )}
      {(type === "form" || type === "button") && (
        <div className="clipboard-button">
          {withPopper ? (
            <Popper popperContent={popperContent} offset={[0, 20]}>
              <Button onClick={onCopy} {...buttonProps}>
                {buttonTitle}
              </Button>
            </Popper>
          ) : (
            <Button onClick={onCopy} {...buttonProps}>
              {buttonTitle}
            </Button>
          )}
        </div>
      )}
      {type === "link" && (
        <>
          {withPopper ? (
            <Popper popperContent={popperContent}>
              <CleanButton onClick={onCopy} style={{ cursor: "pointer" }} {...buttonProps}>
                {children}
              </CleanButton>
            </Popper>
          ) : (
            <CleanButton onClick={onCopy} style={{ cursor: "pointer" }} {...buttonProps}>
              {children}
            </CleanButton>
          )}
        </>
      )}
    </div>
  );
};

MagicLink.propTypes = {
  children: PropTypes.node,
  marketingId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  buttonTitle: PropTypes.string,
  buttonProps: PropTypes.object,
  inputProps: PropTypes.object,
  type: PropTypes.string,
  link: PropTypes.string.isRequired,
  withPopper: PropTypes.bool,
  onSuccess: PropTypes.func,
};

MagicLink.defaultProps = {
  children: null,
  marketingId: null,
  className: "",
  buttonTitle: "Copy Link",
  buttonProps: {},
  inputProps: {},
  type: "form",
  withPopper: false,
  onSuccess: undefined,
};

export default MagicLink;
